import { Action, Module, VuexModule } from "vuex-module-decorators";
import { LawQuestions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class LawQuestionsModule extends VuexModule {
    @Action
    [LawQuestions.findPageLawQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawQuestions/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawQuestions.saveLawQuestions](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawQuestions/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawQuestions.deleteLawQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/lawQuestions/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}